/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-fragments */
//  @flow

import React, { Fragment } from 'react';
import { withTranslation } from 'react-i18next';

//  $Ignore
import { bindActionCreators } from 'redux';
//  $Ignore
import { connect } from 'react-redux';

import Meta from '../../Components/Meta';

import ContentSlider from '../../Components/ContentSlider';
import ExploreCourses from '../../Components/ExploreCourse';
import CallToAction from '../../Components/CallToAction';

import CarouselItem from './CarouselItem';

import Queries from './Queries';

import InformationCad from './InformationCard';
import CompaniesMentors from './CompaniesMentors';
import Courses from './Courses';
import Feedback from './Feedback';
import WorkArea from './WorkArea';
import Figures from './Figures';
import Happenings from './Happenings';

import {
  fetchCompaniesMentors,
  incrementCounter
} from '../../actions/companiesMentors';
import { fetchFeedbacks } from '../../actions/feedback';
import { fetchAllCourses } from '../../actions/course';

import RegistrationForm from '../LiveClass/RegistrationForm';
import Modal from '../../Components/Modal';

import Slide1_png from '../../Assets/v2/home/Slide1.png';
import Slide2_png from '../../Assets/v2/home/Slide2.png';
import Slide3_png from '../../Assets/v2/home/Slide3.png';
import Slide4_png from '../../Assets/v2/home/Slide4.png';

import Slide1_webp from '../../Assets/v2/home/Slide1.webp';
import Slide2_webp from '../../Assets/v2/home/Slide2.webp';
import Slide3_webp from '../../Assets/v2/home/Slide3.webp';
import Slide4_webp from '../../Assets/v2/home/Slide4.webp';

import Slide1_fallback from '../../Assets/fallbacks/home/Slide1.jpg';
import Slide2_fallback from '../../Assets/fallbacks/home/Slide2.jpg';
import Slide3_fallback from '../../Assets/fallbacks/home/Slide3.jpg';
import Slide4_fallback from '../../Assets/fallbacks/home/Slide4.jpg';

import LazyComponent from '../../Components/LazyComponent';

import { getCourses } from '../../selectors/course';

import { getMentors } from '../../selectors/mentors';
import { getFeedbacks } from '../../selectors/feedback';

import './style.css';

const MAX_MODAL_TIMEOUT = 4000;

type HomeProps = {
  location: String,
  fetchCompaniesMentors: () => void,
  fetchFeedbacks: () => void,
  fetchAllCourses: () => void,
  feedbacks: Array<any>,
  mentors: Array<any>,
  courses: Array<any>
};

type HomeState = {};
class Home extends React.Component<HomeProps, HomeState> {
  constructor(props: HomeProps) {
    super(props);
    this.state = {
      modalActive: false,
      register: false,
      isLoading: false
    };
  }

  componentDidMount = () => {
    this.loadData();
  };

  loadData = async () => {
    try {
      const { courses } = this.props;
      const promises = [
        this.props.fetchCompaniesMentors(),
        this.props.fetchFeedbacks()
      ];

      if (courses.length === 0) {
        promises.push(this.props.fetchAllCourses());
      }

      this.toggleLoading();
      await Promise.all(promises);
      this.toggleLoading();
    } catch (err) {
      this.toggleLoading();
    }
  };

  toggleLoading = () => {
    this.setState(prevState => ({
      isLoading: !prevState.isLoading
    }));
  };

  showModal = () => {
    const isAlreadyShown = window.sessionStorage.getItem('isFormShown');
    if (isAlreadyShown) {
      return;
    }

    setTimeout(() => {
      this.toggleModal();
      window.sessionStorage.setItem('isFormShown', true);
    }, MAX_MODAL_TIMEOUT);
  };

  toggleModal = () => {
    this.setState(prevState => ({
      modalActive: !prevState.modalActive
    }));
  };

  showRegister = () => {
    this.setState({ register: true });
  };

  navaigateToCoursePage = courseKey => {
    this.props.history.push(`/live_classes/${courseKey}`);
  };

  navigateToCourses = () => {
    this.props.history.push(`/live_classes`);
  };

  render = () => {
    const { t, courses, fallbackData, mentors, feedbacks } = this.props;
    return (
      <Fragment>
        <Meta
          title="Alien Brains Educations | Your Career in Tech Begins Here"
          description="Live Online Classroom mentorship training program under industry professionals. Summer and winter online training with hands-on learning, live projects & career-support."
        />
        <ContentSlider>
          <CarouselItem
            fallbackImage={Slide4_fallback}
            heading={t('carousel4Heading')}
            text={t('carousel4Text')}
            image={Slide4_png}
            webpImage={Slide4_webp}
            isExternalLink={true}
            linkText="Register"
            linkPath="https://isb.alienbrains.in/register/"
          />

          <CarouselItem
            fallbackImage={Slide1_fallback}
            heading={t('carousel1Heading')}
            text={t('carousel1Text')}
            image={Slide1_png}
            webpImage={Slide1_webp}
            linkText={t('carouselExplore')}
            linkPath="/live_classes"
          />

          <CarouselItem
            fallbackImage={Slide2_fallback}
            heading={t('carousel2Heading')}
            text={t('carousel2Text')}
            image={Slide2_png}
            webpImage={Slide2_webp}
            linkText={t('carouselExplore')}
            linkPath="/live_classes"
          />

          <CarouselItem
            fallbackImage={Slide3_fallback}
            heading={t('carousel3Heading')}
            text={t('carousel3Text')}
            image={Slide3_png}
            webpImage={Slide3_webp}
            linkText={t('carouselExplore')}
            linkPath="/live_classes"
          />
        </ContentSlider>

        <main>
          <Queries link="#home-feedback" text={t('queries')} />

          <LazyComponent>
            <InformationCad />
          </LazyComponent>

          <LazyComponent>
            <WorkArea />
          </LazyComponent>

          <LazyComponent>
            <Figures />
          </LazyComponent>

          <LazyComponent>
            <CompaniesMentors mentors={mentors} />
          </LazyComponent>

          <LazyComponent>
            <Courses
              onCoursesClick={this.navigateToCourses}
              onCourseClick={this.navaigateToCoursePage}
              courses={courses.length > 0 ? courses : fallbackData}
            />
          </LazyComponent>

          <LazyComponent>
            <Feedback feedbacks={feedbacks} />
          </LazyComponent>

          <LazyComponent>
            <Happenings />
          </LazyComponent>

          <LazyComponent>
            <ExploreCourses />
          </LazyComponent>

          <CallToAction />

          <Modal active={this.state.modalActive}>
            <RegistrationForm toggleForm={this.toggleModal} />
          </Modal>
        </main>
      </Fragment>
    );
  };
}

const mapStateToProps = (store, props) => ({
  mentors: getMentors(store, props),
  feedbacks: getFeedbacks(store, props),
  courses: getCourses(store, props),
  fallbackData: store.courseData.fallbackData
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      fetchCompaniesMentors,
      fetchFeedbacks,
      incrementCounter,
      fetchAllCourses
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Home));



// WEBPACK FOOTER //
// ./src/Pages/Home/index.js